<script setup>
import { useMeta } from '@/stores/meta.js'
import NumberInput from '@/components/form/NumberInput.vue'

/** An amount with its currency (D-42). */
const props = defineProps({
  modelValue: { type: [Number, String, null], default: null },
  currency: { type: String, default: null },
  withCurrency: { type: Boolean, default: true },
  disabled: Boolean,
  invalid: Boolean,
  id: { type: String, default: '' },
})
const emit = defineEmits(['update:modelValue', 'update:currency'])
const meta = useMeta()
void props
</script>

<template>
  <div class="flex gap-2">
    <NumberInput :id="id" class="min-w-0 flex-1" :model-value="modelValue" :invalid="invalid" :disabled="disabled" @update:model-value="(v) => emit('update:modelValue', v)" />
    <select v-if="withCurrency" class="input w-24" :value="currency || meta.baseCurrency" :disabled="disabled" @change="emit('update:currency', $event.target.value)">
      <option v-for="c in meta.activeCurrencies" :key="c" :value="c">{{ c }}</option>
    </select>
    <span v-else-if="currency" class="self-center text-sm text-faint">{{ currency }}</span>
  </div>
</template>
